import type { PreviewsStatusProps } from '@components/shared/BudgetPreviewsStatus/types'

const GU_EDITABLE_CL_WEEKLY_PREVIEW_STATUSES: PreviewsStatusProps[] = [
  'in_progress',
  'returned_gu'
]

interface CanEditInvoicingForGuParams {
  canEditPagePermission: boolean
  currentPreviewStatus?: PreviewsStatusProps
  isFirstWeekNotStarted?: boolean
}

export const canEditInvoicingForGu = ({
  canEditPagePermission,
  currentPreviewStatus,
  isFirstWeekNotStarted = false
}: CanEditInvoicingForGuParams) => {
  const canEditByClWeeklyPreviewStatus =
    !!currentPreviewStatus && GU_EDITABLE_CL_WEEKLY_PREVIEW_STATUSES.includes(currentPreviewStatus)

  return canEditPagePermission && (isFirstWeekNotStarted || canEditByClWeeklyPreviewStatus)
}
